/**
 * Mask PII for display. No external libraries.
 */

export const maskEmail = (value) => {
  const email = String(value || "").trim();
  if (!email) return "—";
  const at = email.indexOf("@");
  if (at <= 0) return "***";
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (!domain) return "***";
  const visible = local.slice(0, Math.min(2, local.length));
  return `${visible}***@${domain}`;
};

export const maskMobile = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return "—";
  if (digits.length <= 4) return "*".repeat(digits.length);
  const last4 = digits.slice(-4);
  return `${"*".repeat(Math.max(digits.length - 4, 4))}${last4}`;
};
